module.exports = __webpack_public_path__ + "static/media/Jason Van Yperen.e5b983bc.png";